import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, Platform } from '@ionic/angular';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { ResponsibleGamingService } from 'src/app/services/responsible-gaming-service/responsible-gaming.service';
import { Navigator } from "src/app/components/menu/navigator";
import { LogoutService } from 'src/app/services/logout/logout.service';
import { Subscription } from 'rxjs';
import { SiteContentInterface } from 'src/app/interfaces/sitecontent-interface';
import { SiteContentService } from 'src/app/services/sitecontent/sitecontent.service';
import { SiteContentModel } from 'src/app/models/sitecontent-model';

@Component({
    selector: 'app-cool-off',
    templateUrl: './cool-off.component.html',
    styleUrls: ['./cool-off.component.scss'],
})
export class CoolOffComponent implements OnInit {
    @ViewChild('Content') content: IonContent;

    public error = null;
    public coolOffForm: FormGroup;
    public cool_off: AbstractControl;
    public num_days: number;
    public default_num_days: any;
    public confirm: boolean = false;
    public responsibleGamingNumber: string;
    public environmentName: string;
    public councilLink: string;
    public councilLinkName: string;
    public councilLinkText: string;
    public dgeLink: string;
    public dgeLinkName: string;
    public isMobile: boolean = false;
    public selfExcludePeriod: [] = [];
    private backButtonSubscribtion: Subscription;
    public labels: SiteContentInterface;

    constructor(
        private responsibleGamingProvider: ResponsibleGamingService,
        public platform: Platform,
        protected config: ConfigService,
        private appLinks: AppLinksService,
        private navigator: Navigator,
        private logOutService: LogoutService,
        private siteContentService: SiteContentService
    ) {

        this.labels = new SiteContentModel();

        this.detectMobile();

        let appConfigInfo = this.config.getConfig();
        this.environmentName = appConfigInfo.state;
        this.councilLink = appConfigInfo.COUNCIL_LINK || "https://www.connexontario.ca/en-ca/";
        this.councilLinkName = appConfigInfo.COUNCIL_LINK_NAME || "Mental Health & Addiction Treatment Services | Connex Ontario";
        this.councilLinkText = this.config.getConfig().COUNCIL_LINK_TEXT ||
        "If you need help you can visit the";
        this.num_days = Array.apply(0, Array(28)).map(function (element, index) { return index + 3; });
        try {
            this.selfExcludePeriod = JSON.parse(appConfigInfo.FEATURE_COOLOFF_PERIODS);
        } catch {
            console.error("FEATURE_COOLOFF_PERIODS are not defined.");
            this.navigator.back();
        }

    }
    ngAfterViewInit() {
        this.siteContentService.loadConfig('cool_off')
            .then((response: SiteContentInterface) => {
                this.labels = response
            })
    }

    ngOnInit(): void {
        this.backButtonSubscribtion = this.platform.backButton.subscribeWithPriority(101, () => {
            if (this.navigator.getActivePage() == 'CoolOffPage') {
                this.navigator.navigateTo("LogoutPage", {}, { code: 'INVALID_SESSION_TOKEN', reason: 'BACK_BUTTON_ANDROID' });
            } else {
                this.navigator.back();
            }
        })

        this.responsibleGamingNumber = this.config.getConfig().RESPONSIBLE_GAMING_NUMBER || '1-800-522-4700';
        this.coolOffForm = new FormGroup(
            {
                cool_off: new FormControl('', [Validators.pattern('^[0-9]*')]),
            }
        )

        this.coolOffForm.controls['cool_off'].setValue(3);
        this.cool_off = this.coolOffForm.get('cool_off');
    }

    ngOnDestroy() {
        if (this.backButtonSubscribtion) {
            this.backButtonSubscribtion.unsubscribe();
        }
    }

    protected detectMobile() {
        if (this.platform.is('mobile')) {
            this.isMobile = true;
        } else {
            this.isMobile = false;
        }
    }

    protected onCoolOff() {
        this.coolOffForm.value;
        this.confirm = true;
    }

    protected confirmCoolOff() {
        this.responsibleGamingProvider.setCoolOff(this.coolOffForm.value.cool_off).subscribe(
            (response: any) => {
                if (response && !!response.result) {
                    this.navigator.toLobby();
                    this.logOutService.callLogout({ code: 'INVALID_SESSION_TOKEN', reason: 'PLAYER_COOLOFF' });
                }
            },
            (error) => {
                this.error = error;
            }
        );
    }

    protected goToCouncilLink(): any {
        return this.appLinks.openExternalPage(this.councilLink);
    }

    protected onSetLimits(): any {
        return this.navigator.navigateTo("SetDepositLimitsComponent", { multipleModals: true });
    }

    protected goToSelfExcludePage(): any {
        let url = this.config.getConfig().FEATURE_BOARD_EXCLUSION_SITE_URL;
        return this.appLinks.openExternalPage(url);
    }

    protected onBack = () => {
        if (this.confirm) {
            return this.confirm = false;
        }
        return this.navigator.back();
    }

    public onCancel(): any {
        return this.navigator.dismissAll();
    }
}
